import { EHostKey } from '@loc/hosts/src/constants'

import type { ISiteConfig } from '@/contexts/SiteContext'
import type { TSupportedHostKey } from '@loc/hosts/src/constants'

import tadAiConfig from '@/pages/tad.ai/_config'
import vocalremoverInfoConfig from '@/pages/vocalremover.info/_config'
// [EHostKey-Placeholder]:(import)

const config: Partial<Record<TSupportedHostKey, ISiteConfig>> = {
  [EHostKey.TadAi]: tadAiConfig,
  [EHostKey.VocalremoverInfo]: vocalremoverInfoConfig,
  // [EHostKey-Site]:(config),
}

export default config
